<div class="ta-shell">
  <header
    taHeader
    [isShadowVisible]="uiStore.isHeaderShadowVisible()"
  >
  </header>

  <main class="ta-shell__main">
    <div class="ta-shell__content">
      <router-outlet/>
    </div>
  </main>
</div>
